import { createSlice } from '@reduxjs/toolkit';
export const VOUCHERS_TTL_MS = 15 * 60 * 1000;
export const isVoucherDataExpired = (lastFetchTime) => {
    if (!lastFetchTime)
        return true;
    return Date.now() - lastFetchTime > VOUCHERS_TTL_MS;
};
const initialContractState = {
    products: [],
    isLoading: false,
    isError: false,
    error: null,
    isDataFresh: false,
    lastFetchTime: null,
};
const initialState = {
    contracts: {},
};
const vouchersSlice = createSlice({
    name: 'vouchers',
    initialState,
    reducers: {
        initializeContract: (state, action) => {
            const { contractId } = action.payload;
            if (!state.contracts[contractId]) {
                state.contracts[contractId] = { ...initialContractState };
            }
        },
        setVouchersLoading: (state, action) => {
            const { contractId, isLoading } = action.payload;
            if (!state.contracts[contractId]) {
                state.contracts[contractId] = { ...initialContractState };
            }
            state.contracts[contractId].isLoading = isLoading;
            if (isLoading) {
                state.contracts[contractId].isError = false;
                state.contracts[contractId].error = null;
            }
        },
        setVouchersData: (state, action) => {
            const { contractId, products } = action.payload;
            if (!state.contracts[contractId]) {
                state.contracts[contractId] = { ...initialContractState };
            }
            state.contracts[contractId].products = products;
            state.contracts[contractId].isLoading = false;
            state.contracts[contractId].isError = false;
            state.contracts[contractId].error = null;
            state.contracts[contractId].isDataFresh = true;
            state.contracts[contractId].lastFetchTime = Date.now();
        },
        setVouchersError: (state, action) => {
            const { contractId, error } = action.payload;
            if (!state.contracts[contractId]) {
                state.contracts[contractId] = { ...initialContractState };
            }
            state.contracts[contractId].isLoading = false;
            state.contracts[contractId].isError = true;
            state.contracts[contractId].error = error;
            state.contracts[contractId].isDataFresh = false;
        },
        markVouchersStale: (state, action) => {
            const { contractId } = action.payload;
            if (state.contracts[contractId]) {
                state.contracts[contractId].isDataFresh = false;
            }
        },
        clearVouchersData: (state, action) => {
            const { contractId } = action.payload;
            if (state.contracts[contractId]) {
                state.contracts[contractId] = { ...initialContractState };
            }
        },
        clearAllVouchers: state => {
            state.contracts = {};
        },
    },
});
export const { initializeContract, setVouchersLoading, setVouchersData, setVouchersError, markVouchersStale, clearVouchersData, clearAllVouchers, } = vouchersSlice.actions;
export default vouchersSlice.reducer;
